export default "__VITE_ASSET__54e2582e__"